import React, { useEffect, useMemo, useState } from "react";
import { Pagination, Popover, Input } from "antd";
import "./AppList.css";
import copy from "copy-to-clipboard";
import { message } from "antd";
import { formatUnits } from "ethers";
import { Contract, JsonRpcProvider } from "ethers";
import {
  CacheAddress,
  contract_address,
  getChainInfoById,
} from "../constants/const";
import {
  MarketViewer_Contract_ABI,
  StakingController_Contract_ABI,
  StakingViewer_Contract_ABI,
} from "../constants/abi";
import { useModalStore } from "@/store/modle";
import { useDataStore } from "@/store/dataStore";
import {
  formatBalance,
  formatDecimalWithSeparation,
} from "celer-web-utils/lib/format";
import { formatTokenToUSD, formatTokenAmount } from "../util";
import StakeModal, { tokenDecimals, tokenSymbol } from "./modals/StakeModal";
// import { EmptyRequest, GetAprsResponse, Apr } from "../proto/provernet_pb";
import { getAprs } from "../store/grpc_client";

export interface ProverData {
  proverName?: string;
  proverIcon?: string;
  proverAddress?: string;
  staked?: number | string;
  stakedFormatted?: string;
  proverStaked?: bigint;
  proverStakedFormatted?: string;
  proverStakedDecimal?: string;
  pendingUnstake?: bigint;
  pendingUnstakeFormatted?: string;
  pendingUnstakeDecimal?: string;
  withdrawable?: bigint;
  withdrawableFormatted?: string;
  withdrawableDecimal?: string;
  apr?: number;
  aprFormatted?: string;
  proofsWon?: number;
  feeReceivedFormatted?: string;
  feeReceived?: number;
  fee: bigint;
  successRateFormatted?: string;
  successRate?: number;
  joinedSinceFormatted?: string;
  joinedSince?: number;
  lastActiveFormatted?: string;
  lastActive?: number;
  totalShares?: number;
  isActive?: boolean;
}

export const getLastTimeString = (timestamp: number): string => {
  if (!timestamp || timestamp <= 0) {
    return "--";
  }
  const currentTime = Date.now() / 1000;
  const differenceInSeconds = Math.max(0, Number(currentTime - Number(timestamp)));
  const seconds = differenceInSeconds;
  const minutes = differenceInSeconds / 60;
  const hours = differenceInSeconds / 3600;
  const days = differenceInSeconds / 86400;

  let timeAgo = "";

  if (seconds < 60) {
    timeAgo = `${Math.floor(seconds)} seconds ago`;
  } else if (minutes < 60) {
    timeAgo = `${Math.floor(minutes)} minutes ago`;
  } else if (hours < 24) {
    timeAgo = `${Math.floor(hours)} hours ago`;
  } else if (days < 30) {
    timeAgo = `${Math.floor(days)} days ago`;
  } else {
    const months = days / 30;
    const years = days / 365;
    if (months < 12) {
      timeAgo = `${Math.floor(months)} months ago`;
    } else {
      timeAgo = `${Math.floor(years)} years ago`;
    }
  }
  return timeAgo;
};

const AppList: React.FC = () => {
  const threshold = 10n ** (BigInt(tokenDecimals) - 2n);

  const { dashboardReload, showStakeModal } = useModalStore((state) => state);
  const [loading, setLoading] = useState<boolean>(true);
  const [appsData, setAppsData] = useState<ProverData[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalItems, setTotalItems] = useState<number>(1);
  const [searchText, setSearchText] = useState("");

  const [sortColumn, setSortColumn] = useState<keyof ProverData>("staked");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const { setShowStakeModal } = useModalStore((state) => state);
  const { setSelectedStake, tokenPrice } = useDataStore((state) => state);

  const isMobile = useDataStore((state) => state.isMobile);

  const pageSize = 20;

  // async function getAPRs(provers: string[]): Promise<Apr.AsObject[]> {
  //   let req = new EmptyRequest();
  //   try {
  // const resp: GetAprsResponse = await getAprs(req);
  //     console.log("get aprs>>>>>>>:", resp.toObject());
  //     const { err, arpsList } = resp.toObject();
  //     if (!err) {
  //       console.log("prover apr list:", resp.toObject());
  //     }
  //     return arpsList;
  //   } catch (error) {
  //     console.error("get prover aprs error:", error);
  //     return [];
  //   }
  // }

  async function fetchPageData(page: number) {
    setLoading(true);
    const provider = new JsonRpcProvider(
      getChainInfoById(
        Number(process.env.REACT_APP_PUBLIC_CLAIM_CHAIN || 59144)
      ).rpcUrl
    );

    const staking_controller_contract = new Contract(
      contract_address.staking_controller,
      StakingController_Contract_ABI,
      provider
    );

    const market_viewer_contract = new Contract(
      contract_address.market_viewer,
      MarketViewer_Contract_ABI,
      provider
    );

    const staking_viewer_contract = new Contract(
      contract_address.staking_viewer,
      StakingViewer_Contract_ABI,
      provider
    );

    const allProvers = await staking_controller_contract.getProvers(
      false,
      0,
      0
    );

    const totalItems = allProvers.length;
    const totalPages = Math.ceil(totalItems / pageSize);

    setTotalPages(totalPages);
    setTotalItems(totalItems);

    const start = (page - 1) * pageSize;
    const end = page * pageSize;
    const pageProvers = [...allProvers].slice(start, end);

    // let aprs = await getAprs();
    const ressss = await staking_viewer_contract.getProversInfo(pageProvers);
    console.log("pageProvers:", staking_viewer_contract, ressss);
    const [stats, infos, aprs] = await Promise.allSettled([
      market_viewer_contract.batchGetProverStatsComposite(pageProvers),
      staking_viewer_contract.getProversInfo(pageProvers),
      getAprs(),
    ]);

    if (stats.status === "fulfilled" && infos.status === "fulfilled") {
      const data = stats.value.map((el: any, idx: number) => {
        const info = infos.value[idx];

        const date = new Date(Number(info.joinedAt) * 1000);
        const formattedDate = date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
        let apr: any;
        if (aprs.status === "fulfilled") {
          if (aprs.value && !aprs.value?.err) {
            apr = aprs.value.arps.find(
              (ap: any) =>
                info.prover.toUpperCase() === ap.proverAddr.toUpperCase()
            );
          }
        } else {
          apr = {
            proverAddr: "",
            aprBps: 0,
          };
        }

        // const fee = (el.recent.feeReceived * 100n) / 90n;
        const fee = el.recent.feeReceived;
        const feeNumber = formatUnits(fee, Number(tokenDecimals));
        let feeReceivedFormatted = "";
        if (fee > 0n && fee < threshold) {
          feeReceivedFormatted = `<0.01 ${tokenSymbol}`;
        } else if (fee === 0n) {
          feeReceivedFormatted = `0 ${tokenSymbol}`;
        } else {
          feeReceivedFormatted = formatTokenAmount(
            fee,
            tokenDecimals,
            tokenSymbol
          );
        }

        let res = {
          proofsWon: Number(el.fulfilled),
          successRate: Number(el.successRateBps),
          successRateFormatted: (Number(el.successRateBps) / 100).toFixed(2),
          fee,
          feeReceived: feeNumber,
          feeReceivedFormatted,
          lastActive:
            Number(el.recent.lastActiveAt) || Number(el.total.lastActiveAt),
          lastActiveFormatted: getLastTimeString(
            el.recent.lastActiveAt || el.total.lastActiveAt
          ),

          proverName: info.name,
          proverAddress: info.prover,
          proverIcon: info.iconUrl,
          joinedSince: Number(info.joinedAt),
          joinedSinceFormatted: formattedDate,

          stakedFormatted: formatDecimalWithSeparation(
            info.vaultAssets?.toString(),
            0,
            tokenDecimals,
            "floor",
            ",",
            true
          ),
          staked: Number(info.vaultAssets),
          apr: Number(apr?.aprBps),
          aprFormatted: apr?.aprBps ? (apr?.aprBps / 100).toFixed(2) : 0,
          isActive: Number(info.state) === 1 ? true : false, //1 ProverState.Active
        };
        // console.log("res:", idx, res);
        return res;
      });
      console.log("res9999:", data);
      setAppsData(data);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchPageData(currentPage);
    // eslint-disable-next-line
  }, [currentPage, dashboardReload]);

  const copyText = (address: string) => {
    copy(address || "");
    message.success("copy success !");
  };
  const getIcon = (iconUrl: string | undefined) => {
    let url = iconUrl;
    if (
      iconUrl ===
      "https://picodemo.s3.us-west-2.amazonaws.com/logomark_White.png"
    ) {
      url =
        "https://provernet.brevis.network/favicon.svg";
    }
    return url;
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleSort = (column: keyof ProverData) => {
    if (sortColumn === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortOrder("desc");
    }
  };

  const sortedData = [...appsData].sort((a, b) => {
    const valueA = a[sortColumn];
    const valueB = b[sortColumn];

    if (typeof valueA === "number" && typeof valueB === "number") {
      return sortOrder === "asc" ? valueA - valueB : valueB - valueA;
    } else if (typeof valueA === "string" && typeof valueB === "string") {
      return sortOrder === "asc"
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    }
    return 0;
  });

  const filteredProvers = useMemo(() => {
    return sortedData.filter(
      (p: ProverData) =>
        p.proverAddress?.toLowerCase().includes(searchText.toLowerCase()) ||
        p.proverName?.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [searchText, sortedData]);

  return (
    <>
      <div className="app-list-title">
        <div className="app-list-title-text">
          Select the prover you want to stake {tokenSymbol} with:
        </div>
        <Input
          placeholder="Search by prover address or prover name"
          className="app-list-title-search"
          style={{
            backgroundImage: "url(/search.svg)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "10px center",
            paddingLeft: "32px",
          }}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />

        {/* <input
          type="text"
          className="app-list-title-search"
          placeholder="Search by prover address or prover name"
          style={{
            backgroundImage: "url(/search.svg)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "10px center",
            paddingLeft: "32px",
          }}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        /> */}
      </div>
      <div className="app-list-section">
        {!isMobile && (
          <div className="section-title">
            <div className="stats-prover">
              Prover{" "}
              <img
                src={"/sorted.svg"}
                alt="sort"
                onClick={() => handleSort("proverName")}
                className="sortIcon"
              />
            </div>
            <div className="stats-staked">
              Staked
              <Popover
                placement="top"
                content={`This is the total amount of ${localStorage.getItem(
                  "symbol"
                )} currently staked to this prover.`}
                rootClassName="stat_popover"
              >
                <img src="/info.svg" alt="Brevis" width="16px" />
              </Popover>
              <img
                src={"/sorted.svg"}
                alt="sort"
                onClick={() => handleSort("staked")}
                className="sortIcon"
              />
            </div>
            <div className="stats-apr">
              APR
              <Popover
                placement="top"
                content="This is the estimated APR by staking to this prover. Yields include prover revenue share and additional network incentives."
                rootClassName="stat_popover"
              >
                <img src="/info.svg" alt="Brevis" width="16px" />
              </Popover>
              <img
                src={"/sorted.svg"}
                alt="sort"
                onClick={() => handleSort("apr")}
                className="sortIcon"
              />
            </div>
            <div className="stats-won">
              Proofs Submitted
              <Popover
                placement="top"
                content="This is the total number of proofs successfully submitted by this prover."
                rootClassName="stat_popover"
              >
                <img src="/info.svg" alt="Brevis" width="16px" />
              </Popover>
              <img
                src={"/sorted.svg"}
                alt="sort"
                onClick={() => handleSort("proofsWon")}
                className="sortIcon"
              />
            </div>
            <div className="stats-fee">
              Fee Received{" "}
              <Popover
                placement="top"
                content="This is the total fee received by this prover from proof requests."
                rootClassName="stat_popover"
              >
                <img src="/info.svg" alt="Brevis" width="16px" />
              </Popover>
              <img
                src={"/sorted.svg"}
                alt="sort"
                onClick={() => handleSort("feeReceived")}
                className="sortIcon"
              />
            </div>
            <div
              className="stats-rate"
              style={{ color: "rgba(43, 48, 59, 0.8)" }}
            >
              Success Rate
              <Popover
                placement="top"
                content="This is the percentage of proof requests that were successfully fulfilled by this prover by deadline."
                rootClassName="stat_popover"
              >
                <img src="/info.svg" alt="Brevis" width="16px" />
              </Popover>
              <img
                src={"/sorted.svg"}
                alt="sort"
                onClick={() => handleSort("successRate")}
                className="sortIcon"
              />
            </div>
            <div className="stats-joined">
              Joined Since{" "}
              <img
                src={"/sorted.svg"}
                alt="sort"
                onClick={() => handleSort("joinedSince")}
                className="sortIcon"
              />
            </div>
            <div className="stats-active">
              Last Active{" "}
              <img
                src={"/sorted.svg"}
                alt="sort"
                onClick={() => handleSort("lastActive")}
                className="sortIcon"
              />
            </div>
            <div className="stats-btn">Stake With This Prover</div>
          </div>
        )}
        {loading ? (
          <div className="loading">
            <div className={"loadingBody"}>
              <div
                className={"checkingMotion"}
                style={{ marginTop: 12, marginBottom: 20 }}
              >
                <div className={"checkingMotionThumb"}></div>
              </div>
            </div>
          </div>
        ) : !!filteredProvers.length ? (
          filteredProvers.map((app: ProverData) => {
            return (
              <div className="app-card" key={app.proverAddress}>
                {isMobile ? (
                  <div className="app-mobile-card">
                    <div className="mobile-card-stats">
                      <div className="mobile-stats-left">Prover</div>
                      <div className="mobile-stats-right">
                        <div className="mobile-stats-right-ellipsis">
                          {app.proverName}
                        </div>{" "}
                        <img
                          src={getIcon(app.proverIcon) || "/prover.png"}
                          alt=""
                          style={{ width: 20, height: 20, marginLeft: 6 }}
                        />
                      </div>
                    </div>
                    <div className="mobile-card-stats">
                      <div className="mobile-stats-left">Prover Address</div>
                      <div className="mobile-stats-right">
                        {app.proverAddress?.slice(0, 6) +
                          "..." +
                          app.proverAddress?.slice(
                            app.proverAddress.length - 4,
                            app.proverAddress.length
                          )}
                        <img
                          src={"/copy.svg"}
                          alt="copy"
                          onClick={() => copyText(app.proverAddress || "")}
                          style={{ width: 12, height: 12, marginLeft: 6 }}
                        />
                      </div>
                    </div>
                    <div className="mobile-card-stats">
                      <div className="mobile-stats-left">
                        {" "}
                        Staked{" "}
                        <Popover
                          placement="top"
                          content={`This is the total amount of ${localStorage.getItem(
                            "symbol"
                          )} currently staked to this prover.`}
                          rootClassName="stat_popover"
                        >
                          <img
                            src="/info.svg"
                            alt="Brevis"
                            width="16px"
                            style={{ marginLeft: 4 }}
                          />
                        </Popover>
                      </div>
                      <div className="mobile-stats-right">
                        {app.stakedFormatted} {tokenSymbol}
                      </div>
                    </div>
                    <div className="mobile-card-stats">
                      <div className="mobile-stats-left">
                        {" "}
                        APR{" "}
                        <Popover
                          placement="top"
                          content="This is the estimated APR by staking to this prover. Yields include prover revenue share and additional network incentives."
                          rootClassName="stat_popover"
                        >
                          <img
                            src="/info.svg"
                            alt="Brevis"
                            width="16px"
                            style={{ marginLeft: 4 }}
                          />
                        </Popover>
                      </div>
                      <div className="mobile-stats-right">
                        {app.apr ? (
                          `${app.aprFormatted}%`
                        ) : (
                          <>
                            <span
                              style={{
                                color: "rgba(43, 48, 59, 0.6)",
                                cursor: "auto",
                              }}
                            >
                              N/A
                            </span>
                            {/* <Popover
                              placement="bottom"
                              content={`APR is currently unavailable, as no ${localStorage.getItem(
                                "symbol"
                              )} is staked yet.`}
                              rootClassName="na_popover"
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentElement || document.body
                              }
                            >
                              <img src="/info.svg" alt="Brevis" width="16px" />
                            </Popover> */}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="mobile-card-stats">
                      <div className="mobile-stats-left">
                        {" "}
                        Proofs Submitted{" "}
                        <Popover
                          placement="top"
                          content="This is the total number of proofs successfully submitted by this prover."
                          rootClassName="stat_popover"
                        >
                          <img
                            src="/info.svg"
                            alt="Brevis"
                            width="16px"
                            style={{ marginLeft: 4 }}
                          />
                        </Popover>
                      </div>
                      <div className="mobile-stats-right">{app.proofsWon}</div>
                    </div>
                    <div className="mobile-card-stats">
                      <div className="mobile-stats-left">
                        Fee Received{" "}
                        <Popover
                          placement="top"
                          content="This is the total fee received by this prover from proof requests."
                          rootClassName="stat_popover"
                        >
                          <img
                            src="/info.svg"
                            alt="Brevis"
                            width="16px"
                            style={{ marginLeft: 4 }}
                          />
                        </Popover>
                      </div>
                      <div className="mobile-stats-right">
                        <div>
                          {app?.fee === 0n ? (
                            app?.feeReceivedFormatted
                          ) : (
                            <Popover
                              placement="bottom"
                              content={`${app?.feeReceived} ${tokenSymbol}`}
                              rootClassName="na_popover fee_popover"
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentElement || document.body
                              }
                            >
                              {app?.feeReceivedFormatted}
                            </Popover>
                          )}
                          {/* {app?.feeReceived ? (
                            app?.feeReceived > 0.01 ? (
                              app?.feeReceivedFormatted
                            ) : (
                              <Popover
                                placement="bottom"
                                content={`${app?.feeReceived} ${tokenSymbol}`}
                                rootClassName="na_popover fee_popover"
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentElement || document.body
                                }
                              >
                                {app?.feeReceivedFormatted}
                              </Popover>
                            )
                          ) : (
                            app?.feeReceivedFormatted
                          )} */}
                        </div>
                        <div
                          style={{
                            color: "rgba(43, 48, 59, 0.3)",
                            fontSize: "14px",
                            lineHeight: "20px",
                            fontFamily: "HKNova-Regular",
                            marginLeft: 5,
                          }}
                        >
                          (
                          {formatTokenToUSD(
                            app?.fee?.toString(),
                            tokenDecimals,
                            tokenPrice
                          ) === 0 ? (
                            "$0"
                          ) : (
                            <Popover
                              placement="bottom"
                              content={`$${formatBalance(
                                formatTokenToUSD(
                                  app?.fee?.toString(),
                                  tokenDecimals,
                                  tokenPrice
                                ),
                                8,
                                "floor",
                                ",",
                                true
                              )}`}
                              rootClassName="na_popover fee_popover"
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentElement || document.body
                              }
                            >
                              {formatTokenToUSD(
                                app?.fee?.toString(),
                                tokenDecimals,
                                tokenPrice
                              ) < 0.01
                                ? "$<0.01"
                                : `$${formatBalance(
                                    formatTokenToUSD(
                                      app?.fee?.toString(),
                                      tokenDecimals,
                                      tokenPrice
                                    ),
                                    4,
                                    "floor",
                                    ",",
                                    true
                                  )}`}
                            </Popover>
                          )}
                          )
                        </div>
                      </div>
                    </div>
                    <div className="mobile-card-stats">
                      <div className="mobile-stats-left">
                        Success Rate{" "}
                        <Popover
                          placement="top"
                          content="This is the percentage of proof requests that were successfully fulfilled by this prover by deadline."
                          rootClassName="stat_popover"
                        >
                          <img
                            src="/info.svg"
                            alt="Brevis"
                            width="16px"
                            style={{ marginLeft: 4 }}
                          />
                        </Popover>
                      </div>
                      <div
                        className="mobile-stats-right"
                        style={{ color: "#1C9444" }}
                      >
                        {app.successRateFormatted === "0.00" ? (
                          <>
                            <span
                              style={{
                                color: "rgba(43, 48, 59, 0.6)",
                                cursor: "auto",
                              }}
                            >
                              N/A
                            </span>
                            <Popover
                              placement="bottom"
                              content={
                                "Success rate is currently unavailable, as no proof requests have been fulfilled yet."
                              }
                              rootClassName="na_popover"
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentElement || document.body
                              }
                            >
                              <img src="/info.svg" alt="Brevis" width="16px" />
                            </Popover>
                          </>
                        ) : (
                          `${app.successRateFormatted}%`
                        )}
                      </div>
                    </div>
                    <div className="mobile-card-stats">
                      <div className="mobile-stats-left">Joined Since</div>
                      <div className="mobile-stats-right">
                        {app.joinedSinceFormatted}
                      </div>
                    </div>
                    <div className="mobile-card-stats">
                      <div className="mobile-stats-left">Last Active</div>
                      <div
                        className="mobile-stats-right"
                        style={{
                          color:
                            app.lastActiveFormatted === "--"
                              ? "rgba(43, 48, 59, 0.6)"
                              : "",
                        }}
                      >
                        {app.lastActiveFormatted}
                      </div>
                    </div>
                    <div className="stats-btn">
                      {!localStorage.getItem(CacheAddress.cacheAddress) ? (
                        <div className="btn" data-disabled={true}>
                          Stake
                        </div>
                      ) : !app.isActive ? (
                        <Popover
                          placement="bottom"
                          content={
                            "This prover is currently inactive and staking is not available."
                          }
                          rootClassName="na_popover"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement || document.body
                          }
                        >
                          <div className="btn" data-disabled={true}>
                            Stake
                          </div>
                        </Popover>
                      ) : (
                        <div
                          className="btn"
                          onClick={() => {
                            setSelectedStake(app);
                            setShowStakeModal(true);
                          }}
                        >
                          Stake
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="app-card-stats">
                    <div className="stats-prover">
                      <img
                        src={getIcon(app.proverIcon) || "/prover.png"}
                        alt=""
                        style={{
                          width: 44,
                          height: 44,
                          marginRight: 6,
                          borderRadius: "100%",
                        }}
                      />
                      <div className="stats-prover-right">
                        <div className="stats-prover-name">
                          {app.proverName}
                        </div>{" "}
                        <div className="stats-prover-addr">
                          {app.proverAddress?.slice(0, 6) +
                            "..." +
                            app.proverAddress?.slice(
                              app.proverAddress.length - 4,
                              app.proverAddress.length
                            )}
                          <img
                            src={"/copy.svg"}
                            alt="copy"
                            onClick={() => copyText(app.proverAddress || "")}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`stats-staked ${
                        app.staked === 0 ? "stats-zero" : ""
                      }`}
                    >
                      {app.stakedFormatted} {tokenSymbol}
                    </div>
                    <div className="stats-apr">
                      {app.apr ? (
                        `${app.aprFormatted}%`
                      ) : (
                        <>
                          <span
                            style={{
                              color: "rgba(43, 48, 59, 0.6)",
                              cursor: "auto",
                            }}
                          >
                            N/A
                          </span>
                          {/* <Popover
                            placement="bottom"
                            content={`APR is currently unavailable, as no ${localStorage.getItem(
                              "symbol"
                            )} is staked yet.`}
                            rootClassName="na_popover"
                            getPopupContainer={(triggerNode) =>
                              triggerNode.parentElement || document.body
                            }
                          >
                            <img src="/info.svg" alt="Brevis" width="16px" />
                          </Popover> */}
                        </>
                      )}
                    </div>
                    <div
                      className={`stats-won ${
                        app.proofsWon === 0 ? "stats-zero" : ""
                      }`}
                    >
                      {app.proofsWon}
                    </div>
                    <div
                      className={`stats-fee stats-fee-format ${
                        app.fee === 0n ? "stats-zero" : ""
                      }`}
                    >
                      <div
                        style={{
                          lineHeight: "20px",
                        }}
                      >
                        {app?.fee === 0n ? (
                          app?.feeReceivedFormatted
                        ) : (
                          <Popover
                            placement="bottom"
                            content={`${app?.feeReceived} ${tokenSymbol}`}
                            rootClassName="na_popover fee_popover"
                            getPopupContainer={(triggerNode) =>
                              triggerNode.parentElement || document.body
                            }
                          >
                            {app?.feeReceivedFormatted}
                          </Popover>
                        )}
                        {/* {app?.feeReceived ? (
                          <Popover
                            placement="bottom"
                            content={`${app?.feeReceived} ${tokenSymbol}`}
                            rootClassName="na_popover fee_popover"
                            getPopupContainer={(triggerNode) =>
                              triggerNode.parentElement || document.body
                            }
                          >
                            {app?.feeReceivedFormatted}
                          </Popover>
                        ) : (
                          app?.feeReceivedFormatted
                        )} */}
                      </div>
                      <div
                        style={{
                          color: "rgba(43, 48, 59, 0.3)",
                          fontSize: "12px",
                          lineHeight: "16px",
                          fontFamily: "HKNova-Regular",
                          position: "absolute",
                          bottom: "-15px",
                        }}
                      >
                        (
                        {formatTokenToUSD(
                          app?.fee?.toString(),
                          tokenDecimals,
                          tokenPrice
                        ) === 0 ? (
                          "$0"
                        ) : (
                          <Popover
                            placement="bottom"
                            content={`$${formatBalance(
                              formatTokenToUSD(
                                app?.fee?.toString(),
                                tokenDecimals,
                                tokenPrice
                              ),
                              8,
                              "floor",
                              ",",
                              true
                            )}`}
                            rootClassName="na_popover fee_popover"
                            getPopupContainer={(triggerNode) =>
                              triggerNode.parentElement || document.body
                            }
                          >
                            {formatTokenToUSD(
                              app?.fee?.toString(),
                              tokenDecimals,
                              tokenPrice
                            ) < 0.01
                              ? "$<0.01"
                              : `$${formatBalance(
                                  formatTokenToUSD(
                                    app?.fee?.toString(),
                                    tokenDecimals,
                                    tokenPrice
                                  ),
                                  4,
                                  "floor",
                                  ",",
                                  true
                                )}`}
                          </Popover>
                        )}
                        )
                      </div>
                    </div>
                    <div className="stats-rate">
                      {app.successRateFormatted === "0.00" ? (
                        <>
                          <span
                            style={{
                              color: "rgba(43, 48, 59, 0.6)",
                              cursor: "auto",
                            }}
                          >
                            N/A
                          </span>
                          <Popover
                            placement="bottom"
                            content={
                              "Success rate is currently unavailable, as no proof requests have been fulfilled yet."
                            }
                            rootClassName="na_popover"
                            getPopupContainer={(triggerNode) =>
                              triggerNode.parentElement || document.body
                            }
                          >
                            <img src="/info.svg" alt="Brevis" width="16px" />
                          </Popover>
                        </>
                      ) : (
                        `${app.successRateFormatted}%`
                      )}
                    </div>
                    <div className="stats-joined">
                      {app.joinedSinceFormatted}
                    </div>
                    <div
                      className="stats-active"
                      style={{
                        color:
                          app.lastActiveFormatted === "--"
                            ? "rgba(43, 48, 59, 0.6)"
                            : "",
                      }}
                    >
                      {app.lastActiveFormatted}
                    </div>
                    {/* localStorage.getItem(CacheAddress.cacheAddress) */}

                    <div className="stats-btn">
                      {!localStorage.getItem(CacheAddress.cacheAddress) ? (
                        <div className="btn" data-disabled={true}>
                          Stake
                        </div>
                      ) : !app.isActive ? (
                        <Popover
                          placement="bottom"
                          content={
                            "This prover is currently inactive and staking is not available."
                          }
                          rootClassName="na_popover"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement || document.body
                          }
                        >
                          <div className="btn" data-disabled={true}>
                            Stake
                          </div>
                        </Popover>
                      ) : (
                        <div
                          className="btn"
                          onClick={() => {
                            setSelectedStake(app);
                            setShowStakeModal(true);
                          }}
                        >
                          Stake
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="stakingCardEmpty">
            <img
              src={
                "https://brevis-frontend.s3.us-west-1.amazonaws.com/provenet/imgs/emptyCat.svg"
              }
              alt="emptyCat"
            />
          </div>
        )}
        {totalPages > 20 && !loading && (
          <div className="pagination-container">
            <Pagination
              current={currentPage}
              onChange={handlePageChange}
              total={totalItems}
              pageSize={pageSize}
              showSizeChanger={false}
            />
          </div>
        )}
      </div>
      {showStakeModal && <StakeModal />}
    </>
  );
};

export default AppList;
